import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { APTContext } from "src/app/services/aptContext/apt-context";
import { waitForEngagementDetailsFetched } from "src/standard/guards/can-match/waitForEngagementDetailsFetched";

export type NumericFilterOp =
  | "Equals"
  | "NotEquals"
  | "GreaterThan"
  | "LessThan"
  | "GreaterThanOrEqual"
  | "LessThanOrEqual";

export const AptVersionCanActivateGuard = (
  targetVersion: number,
  queryOp: NumericFilterOp,
): CanActivateFn => {
  return async (route) => {
    const aptContext = inject(APTContext);
    let canMatch = false;

    try {
      await waitForEngagementDetailsFetched(aptContext);
      const version = aptContext.engagementVersion();

      switch (queryOp) {
        case "Equals":
          canMatch = version === targetVersion;
          break;
        case "NotEquals":
          canMatch = version !== targetVersion;
          break;
        case "GreaterThan":
          canMatch = version > targetVersion;
          break;
        case "LessThan":
          canMatch = version < targetVersion;
          break;
        case "GreaterThanOrEqual":
          canMatch = version >= targetVersion;
          break;
        case "LessThanOrEqual":
          canMatch = version <= targetVersion;
          break;
        default: {
          const _: never = queryOp;
          throw new Error();
        }
      }
      return canMatch;
    } catch (error) {
      // Handle the timeout error here
      return false;
    }
  };
};
